
















import { Component, Vue } from "vue-property-decorator";
import { NotifFilter } from "@/store/modules/types";
import { MessageType } from "@/store/modules/enums";
import Header from "@/components/Header.vue";
import EntityTabs from "@/components/EntityTabs.vue";
import NotifSearch from "@/components/notif/NotifSearch.vue";
import NotifList from "@/components/notif/NotifList.vue";
import NotifDetail from "@/components/notif/NotifDetail.vue";

@Component({
  components: {
    Header,
    EntityTabs,
    NotifSearch,
    NotifList,
    NotifDetail,
  },
})
export default class Notifications extends Vue {
  filter: NotifFilter = {
    messageType: MessageType.ANY,
    recordDateFrom: null,
    recordDateTo: null,
    toPhone: "",
  };
  pageRows: Array<any> = [];
  totalRows: number = 0;
  selected: any = null;
  async getNotifs() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const data = await this.$store.dispatch("notifs/getList", this.filter);
      this.totalRows = data.length;
      this.pageRows = data;
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async showDetail(batch) {
    this.selected = batch;
    this.$modal.show("notif-detail");
  }
  mounted() {
    this.getNotifs();
  }
}
